/** SF-4779 — Security tab copy, shared with its tests. */
export const TWO_STEP_SWITCH_LABEL =
  'Require two-step sign-in for everyone who signs in with a password';
export const TWO_STEP_CONFIRM_ON = {
  title: 'Require two-step sign-in?',
  description:
    'People in this company who sign in with a password will be asked to set up two-step sign-in at their next sign-in. Single sign-on and Google sign-ins are not affected.',
  okText: 'Require it',
};
export const TWO_STEP_CONFIRM_OFF = {
  title: 'Stop requiring two-step sign-in?',
  description:
    'People in this company will no longer have to use two-step sign-in. Anyone who has already set it up keeps it until they turn it off or it is reset.',
  okText: 'Stop requiring',
};
export const TWO_STEP_RESET_CONFIRM =
  'Reset two-step sign-in for this person? They will have to set it up again if it is required.';
/** Contract v3: shown while the platform flag two_step_signin_available is off. */
export const TWO_STEP_NOT_AVAILABLE_TEXT =
  "Two-step sign-in can't be required yet. Turn on the platform flag first.";
export const TWO_STEP_LOAD_FAILED = 'Could not load the latest list. Showing the last one loaded.';
